import * as React from 'react';
import { connect } from 'react-redux';
//@ts-ignore
//!!r-18-dj
import { useHistory } from 'react-router-dom';
import { AppState } from '../../../store';
import './index.css';

export interface AccessControlProps {
    /**  Children to control access to */
    children: any,
    allowedRoles : {
        [key : string] : Array<string>
    },
    /** Renders if the user does not have access. Accepts a react component or null */
    renderNoAccess? : any | null,
    userRoles : Array<string>,
    target : string | Array<string>,
    showTargets: boolean
}

const AccessControl: React.FC<AccessControlProps> = (props: AccessControlProps) => {
    const {allowedRoles, renderNoAccess, userRoles, target, showTargets} = props;
    const history: any = useHistory();
    
    const checkIfValid = ():boolean => {
        if(typeof target === "string"){
            // Have logic in here that gets PortalSettings.AllowedRoles[target]
            // Check the length return true if length is 0
            // Else have logic that goes through PortalSettings.AllowedRoles[target] array
            // and see if the user has one of those roles
            // if user does have one return true
            // else return false
            // all I have to do is
            if(target === "none" || target === "DEFAULT"){
                return true;
            }
            if(target === "dev" || target === "DEV"){
                return process.env.NODE_ENV === "development";
            }
            // If a target is passed in that doesn't exist on the database is
            // pased in return false for security reasons
            else if(!allowedRoles[target]){
                return false;
            }
            const targetRoles = allowedRoles[target];
            return targetRoles ? targetRoles.some(role => userRoles.includes(role)) : false;
            // return allowedRoles.some(role => userRoles.includes(role));
        }else{
            let hasRequiredPermission: boolean = false;
            target.forEach((t: string) => {
                const targetRoles: any = allowedRoles[t];
                let included: boolean = targetRoles ? targetRoles.some((role: any) => userRoles.includes(role)) : false;
                if(included) hasRequiredPermission = true;
            });
            return hasRequiredPermission;
        }
    }

    React.useEffect(() => {
        checkIfValid();
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [history])

    // const AttributeInjector = (children: any) => {
    //     const StyledChildren = () =>
    //     React.Children.map(children, child =>
    //         React.cloneElement(child, {
    //             "data-access": `CONTROLLED`
    //         })
    //     );
    //     return <StyledChildren />;
    // };

    if(checkIfValid()){
        if(showTargets){
            return(
                React.Children.map(props.children, child => {
                    return React.cloneElement(child, {
                        // key: index,
                        "data-access": `controlled`,
                        "data-targets": JSON.stringify(target),
                        "data-has-access": checkIfValid(),
                    });
                })
            );
        }else{
            return props.children;
        }
    }else{
        return renderNoAccess;
    }
    // return(checkIfValid() ? AttributeInjector(props.children) : renderNoAccess);
}

const mapStateToProps = (state: AppState) => ({
    userRoles: state.user.roles,
    allowedRoles : state.user.PortalSettings.AllowedRoles,
    showTargets: state.devTools.showTargets
})

AccessControl.defaultProps = {
    renderNoAccess : null,
    target : "none",
} as Partial<AccessControlProps>;

export default connect(mapStateToProps)(AccessControl);